var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    zoomAndPan: "magnify",
    viewBox: "0 0 112.5 112.499997",
    height: 150,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f60000",
    d: "M 44.734375 70.484375 L 44.734375 39.054688 C 55.894531 44.304688 64.535156 49.378906 74.753906 54.84375 C 66.324219 59.519531 55.894531 64.761719 44.734375 70.484375 M 106.910156 23.425781 C 104.988281 20.890625 101.707031 18.917969 98.214844 18.265625 C 87.949219 16.316406 23.917969 16.3125 13.660156 18.265625 C 10.859375 18.789062 8.367188 20.058594 6.222656 22.027344 C -2.800781 30.40625 0.0273438 75.332031 2.203125 82.609375 C 3.117188 85.757812 4.300781 88.03125 5.789062 89.519531 C 7.707031 91.492188 10.335938 92.851562 13.351562 93.457031 C 21.804688 95.207031 65.34375 96.183594 98.035156 93.71875 C 101.050781 93.195312 103.714844 91.796875 105.816406 89.738281 C 114.164062 81.398438 113.59375 33.945312 106.910156 23.425781 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.5c4fe5c443cf16817f1c125f89447434.svg";
export { ForwardRef as ReactComponent };